import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotFoundComponent } from '../pages/not-found/not-found.component';
import { HomeComponent } from '../pages/home/home.component';
import { LoginComponent } from '../pages/login/login.component';
import { FlightModule } from '../flight/fight.module';
import { MatCardModule } from '@angular/material/card';
import { SharedModule } from '../shared/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { PagesRoutingModule } from './pages-routing.module';
import { PrivacyPolicyComponent } from './login/privacy-policy/privacy-policy.component';


@NgModule({
  declarations: [
    LoginComponent,
    HomeComponent,
    NotFoundComponent,
    PrivacyPolicyComponent
  ],
  imports: [
    PagesRoutingModule,
    MatCardModule,
    MatDialogModule,
    CommonModule,
    SharedModule,
    FlightModule
  ],
  exports: [
    LoginComponent,
    HomeComponent,
    NotFoundComponent
  ]
})
export class PagesModule { }
